export const RouteNames = {
  Channels: 'Channels',
  Channel: 'Channel',
  Video: 'Video',
  MdmSetup: 'MdmSetup',
  Login: 'Login',
  NotFound: 'NotFound',
} as const;
